import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import AuthHeader from '../auth-header/AuthHeader';
import Typography from '../typography/Typography';
import { CloseIcon } from '../assets';
import { TwoFactorAuth, } from '../two-factor-auth/TwoFactorAuth';
import { Container, Header, TwoFaWrap, TwoFaWrapper, CustomCloseButton, IconWrapper, } from './styles';
const TwoFactorAuthPage = ({ changeLanguage, selectedLanguage, headerButtonTitle, hasHeader = true, title, className, mobileLogo, logo, onCancel, jurisdictionId, ...rest }) => {
    const { colors } = useTheme();
    const navigate = useNavigate();
    const handleTwoFaCompletion = useCallback((nextTwoFa) => {
        navigate(`?type=${nextTwoFa}`, {
            replace: true,
        });
    }, [navigate]);
    const handleSuccessTwoFa = useCallback(() => {
        navigate('/', { replace: true });
    }, [navigate]);
    const handleRegisterClick = () => {
        navigate('/register');
    };
    return (_jsxs(_Fragment, { children: [hasHeader && (_jsx(AuthHeader, { jurisdictionId: jurisdictionId, logo: logo, mobileLogo: mobileLogo, selectedLanguage: selectedLanguage, changeLanguage: changeLanguage, buttonTitle: headerButtonTitle, onButtonClick: handleRegisterClick })), _jsx(Container, { className: className, children: _jsx(TwoFaWrap, { children: _jsxs(TwoFaWrapper, { children: [_jsxs(Header, { children: [_jsx(Typography, { fontFamily: "primaryBold", type: "headline", children: title }), _jsx(CustomCloseButton, { onClick: onCancel, children: _jsx(IconWrapper, { children: _jsx(CloseIcon, { color: colors.text.default }) }) })] }), _jsx(TwoFactorAuth, { onComplete: handleTwoFaCompletion, onAuthFinish: handleSuccessTwoFa, ...rest })] }) }) })] }));
};
export default TwoFactorAuthPage;
//# sourceMappingURL=TwoFactorAuthPage.js.map